import React from 'react'
import { useTranslation } from 'react-i18next';

function Contact() {
  const { t } = useTranslation();

  return (
 <main className="page-content">
  <div className="tm-section tm-contact-area tm-padding-section bg-white">
    <div className="container">
      <div className="tm-contact-forms tm-padding-section-top">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-12">
            <div className="tm-sectiontitle text-center">
              <h3>{t("sendmessage")}</h3>
              <p>{t("sendmessagecontent")}
              </p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <form id="tm-contactform" action className="tm-contact-forminner tm-form" method="POST">
              <div className="tm-form-inner">
                <div className="tm-form-field tm-form-fieldhalf">
                  <label htmlFor="contact-form-name">{t("Name")}</label>
                  <input type="text" id="contact-form-name" placeholder={t("Name_content")} name="name" required />
                </div>
                <div className="tm-form-field tm-form-fieldhalf">
                  <label htmlFor="contact-form-email">{t("Email")}</label>
                  <input type="email" id="contact-form-email" placeholder={t("Email_content")} name="email" required />
                </div>
                <div className="tm-form-field tm-form-fieldhalf">
                  <label htmlFor="contact-form-phone">{t("phone")}</label>
                  <input type="text" id="contact-form-phone" placeholder={t("Phone_content")} name="phone" required />
                </div>
                <div className="tm-form-field tm-form-fieldhalf">
                  <label htmlFor="contact-form-subject">{t("subject")}</label>
                  <input type="text" id="contact-form-subject" placeholder={t("Subject_content")}name="subject" />
                </div>
                <div className="tm-form-field">
                  <label htmlFor="contact-form-message">{t("Message")}</label>
                  <textarea cols={30} rows={5} id="contact-form-message" placeholder={t("Message_Content")} name="message" defaultValue={""} />
                </div>
                <div className="tm-form-field text-center">
                  <button type="submit" className="tm-button tm-button-block">{t("send_message")}</button>
                </div>
              </div>
            </form>
            <p className="form-messages" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="google-map" className="google-map">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d227748.86053520977!2d75.79055784999998!3d26.885210750000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4adf4c57e281%3A0xce1c63a0cf22e09!2sJaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1711544064963!5m2!1sen!2sin" width="100%" height={350} style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
  </div>
</main>

  )
}

export default Contact